import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";
import { setDocTitle } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next.js";
import { download } from "../../../functions/download";

export default {
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      collections: null,
      query: this.$route.params.query,
      files: [],
      doneSearching: false,
      extensionsFilter: [],
      typesFilter: [],
      filterdItems: [],
      actionBtns: {},
    };
  },

  created() {
    this.setActionBtns();

    setDocTitle("search", this);

    if (this.company_full.isActive == "trial-expired") {
      location.href = "/" + this.$store.state.company + "/billing";
    } else {
      var urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("q")) {
        this.query = urlParams.get("q");
      }

      this.getFiles();

      EventBus.$on(`desktop-files-update`, () => {
        this.getFiles();
      });

      EventBus.$on("filterByExtensionAndType", (data) => {
        this.extensionsFilter = data.extensions;
        this.typesFilter = data.types;

        this.filterItems();
      });

      EventBus.$on("login", (id) => {
        this.user = this.$store.state.user;
      });
      EventBus.$on("extensions", (data) => {
        this.extensions = [];
        for (var i = 0; i < data.length; i++) {
          if (
            data[i].extension &&
            !this.extensions.includes(data[i].extension)
          ) {
            this.extensions.push(data[i].extension);
          }
        }
      });

      EventBus.$on("search--getMoreFiles", (data) => {
        // this.getMoreFiles(data.page);
      });

      if (this.user) {
        this.$axios.get(baseUrl + "/collectionsall").then((response) => {
          this.collections = response.data;
        });
      }
      if (this.user) {
        EventBus.$on("collectioncount", (id) => {
          this.$axios.get(baseUrl + "/collectionsall").then((response) => {
            this.collections = response.data;
          });
        });
      }

      this.addBtnListeners();
    }
  },
  methods: {
    openFileDetail() {
      if (this.files.length && this.$route.params.file) {
        //has files and ad file id
        //get file data
        const fileData = this.files.filter(
          (file) => file.id === this.$route.params.file
        )[0];

        //emit open detail
        EventBus.$emit("openOverlayPage", {
          id: "file-detail",
          file: fileData,
        });
      }
    },
    addBtnListeners() {
      [...this.actionBtns.defaultBtns, ...this.actionBtns.selectedBtns].forEach(
        (btn) => {
          EventBus.$on(btn.emitterName, (data) => {
            if (btn.func) {
              btn.func(data);
            } else {
              this.openRightSidebar(
                btn.emitterName.substring(btn.emitterName.lastIndexOf("-") + 1),
                {
                  mySpace: 0,
                }
              );
            }
          });
        }
      );
    },
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data,
      });
    },
    setActionBtns() {
      this.actionBtns = {
        defaultBtns: [],
        selectedBtns: [
          {
            name: i18n.tc("common.download"),
            icon: "download",
            emitterName: `${this.$options.name}-downloadSelected`,
            emitterData: {},
            rights: ["download_folders", "download_files"],
            func: (data) => this.downloadSelected(data),
          },
          {
            name: i18n.t("transfer.transfer"),
            icon: "transfer",
            emitterName: `${this.$options.name}-transfer`,
            emitterData: {},
            rights: ["transfer_folders", "transfer_files"],
            func: () => this.transferSelected(),
          },
          {
            name: i18n.t("collection.collect"),
            icon: "collect",
            emitterName: `${this.$options.name}-collect`,
            emitterData: {},
            rights: ["collect"],
          },
          {
            name: i18n.t("common.delete"),
            icon: "delete--alt",
            rights: ["delete_files", "delete_folders"],
            emitterName: `${this.$options.name}-delete`,
            emitterData: {},
            func: () => this.deleteSelected(),
          },
        ],
      };
    },
    downloadSelected(e) {
      download(
        {
          type: "multi",
          items: this.$store.state.transferItems,
          btn: e.event.currentTarget,
        },
        this
      );
    },
    transferSelected() {
      EventBus.$emit(`right-sidebar-show`, {
        id: "transfer",
        data: [
          ...this.$store.state.transferItems.selectedFiles,
          ...this.$store.state.transferItems.selectedFolders,
        ],
      });
    },
    deleteSelected() {
      EventBus.$emit(`right-sidebar-show`, {
        id: "delete",
        data: [
          ...this.$store.state.transferItems.selectedFiles,
          ...this.$store.state.transferItems.selectedFolders,
        ],
      });
    },
    getFiles() {
      this.doneSearching = false;

      this.folderId = this.$route.params.id;
      this.$axios
        .get(baseUrl + "/searchv2?q=" + this.query + "&full&limit=100000", {
          responseType: "json",
        })
        .then((r) => {
          this.files = r.data.result.Branding.list;

          this.filterItems();

          this.doneSearching = true;
        });
    },

    getMoreFiles(page) {
      this.$axios
        .get(baseUrl + "/searchv2?q=" + this.query + "&full&page" + page, {
          responseType: "json",
        })
        .then((r) => {
          this.files += r.data.result.Branding.list;

          this.filterItems();
        });
    },

    filterItems() {
      this.filterdItems = this.files.filter((item) => {
        let hasEverything = true;

        //check types
        if (this.typesFilter.length) {
          let typeHere = false;
          this.typesFilter.forEach((type) => {
            if (type === "file" && item.extension !== undefined) {
              typeHere = true;
            }

            if (type === "folder" && item.extension === undefined) {
              typeHere = true;
            }
          });

          hasEverything = typeHere;
        }

        //check extension
        if (hasEverything && this.extensionsFilter.length) {
          if (
            this.extensionsFilter.filter((ext) => ext === item.extension).length
          ) {
            //nothing found
            hasEverything = false;
          }
        }

        return hasEverything;
      });
    },
    toggleExtensions(event) {
      if ($(this.$refs.extensionoptions).hasClass("active")) {
        $(event.target).removeClass("active");
        $(this.$refs.extensionoptions).removeClass("active");
      } else {
        $(event.target).addClass("active");
        $(this.$refs.extensionoptions).addClass("active");
      }
    },
    toggleTypes(event) {
      if ($(this.$refs.typesoptions).hasClass("active")) {
        $(event.target).removeClass("active");
        $(this.$refs.typesoptions).removeClass("active");
      } else {
        $(event.target).addClass("active");
        $(this.$refs.typesoptions).addClass("active");
      }
    },
  },
};
